import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");

  const currentPath = window.location.pathname;

  // ✅ Allow OAuth success page
  if (currentPath === "/oauth-success") {
    return children;
  }

  // ✅ Allow if either login method exists
  if (!user && !token) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;